import _regeneratorRuntime from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { getNewToken } from './getNewToken';
import { getAccessTokenFromMemory } from './getAccessTokenFromMemory';
import { MetricTypes } from '@spotify-internal/semantic-metrics';
import { MetricActions, defaultTags, sendMetric } from './utils/metricsHelper';

var getNewAccessToken = function getNewAccessToken(clientConfig, authServerConfig) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var token;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getNewToken(clientConfig, authServerConfig);

          case 2:
            token = _context.sent;
            return _context.abrupt("return", token.access_token);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var doFetch = function doFetch(input, init, accessToken) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var headers;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            headers = Object.assign(Object.assign({}, init.headers), {
              Authorization: "Bearer ".concat(accessToken)
            });
            return _context2.abrupt("return", fetch(input, Object.assign(Object.assign({}, init), {
              headers: headers
            })));

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

var fetchAuthorized = function fetchAuthorized(input, init, clientConfig, authServerConfig) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3() {
    var accessToken, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            sendMetric({
              metric_type: MetricTypes.COUNTER,
              what: MetricActions.FETCH_AUTHORIZED,
              value: 1,
              tags: Object.assign({
                clientId: clientConfig.clientId,
                serverUrl: authServerConfig.url
              }, defaultTags)
            });
            _context3.t0 = getAccessTokenFromMemory();

            if (_context3.t0) {
              _context3.next = 6;
              break;
            }

            _context3.next = 5;
            return getNewAccessToken(clientConfig, authServerConfig);

          case 5:
            _context3.t0 = _context3.sent;

          case 6:
            accessToken = _context3.t0;
            _context3.next = 9;
            return doFetch(input, init, accessToken);

          case 9:
            response = _context3.sent;

            if (!(response.status === 401)) {
              _context3.next = 20;
              break;
            }

            _context3.t1 = doFetch;
            _context3.t2 = input;
            _context3.t3 = init;
            _context3.next = 16;
            return getNewAccessToken(clientConfig, authServerConfig);

          case 16:
            _context3.t4 = _context3.sent;
            _context3.next = 19;
            return (0, _context3.t1)(_context3.t2, _context3.t3, _context3.t4);

          case 19:
            return _context3.abrupt("return", _context3.sent);

          case 20:
            return _context3.abrupt("return", response);

          case 21:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};

export { fetchAuthorized };